import {
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { ApplicationQuery } from 'src/app/state/application/application.query';
import { MiniFabComponent } from './mini-fab.component';

@Directive({
  selector: '[appMiniFab]',
})
export class MiniFabDirective implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @Output() moveright = new EventEmitter<void>();
  @Output() movedown = new EventEmitter<void>();

  @Input('mini-fab-disabled') set disabled(value: boolean) {
    // If disabling while component exists, destroy it.
    if (value) {
      this.ngOnDestroy();
    }
  }

  private compRef: ComponentRef<MiniFabComponent> | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private vcr: ViewContainerRef,
    private injector: Injector,
    private renderer: Renderer2,
    private appQuery: ApplicationQuery
  ) {}

  ngOnInit(): void {
    // Only create the component if the user setting allows it, and not disabled by input.
    const showButtons = !!this.appQuery.showTableCellEditorButtons;
    if (!showButtons || this.disabled) {
      return;
    }

    // create the Angular component and attach its host element to the directive's host
    this.compRef = this.vcr.createComponent(MiniFabComponent, {
      injector: this.injector,
    });

    const hostEl = this.el.nativeElement;
    // ensure host is positioned relatively so the absolute-positioned mini-fab can align
    const computed = getComputedStyle(hostEl).position;
    if (!computed || computed === 'static') {
      this.renderer.setStyle(hostEl, 'position', 'relative');
    }

    // append the component's root node(s) to the host element
    const compRootNode = this.compRef.location.nativeElement as HTMLElement;
    this.renderer.appendChild(hostEl, compRootNode);

    // wire outputs
    this.compRef.instance.close.subscribe(() => this.close.emit());
    this.compRef.instance.moveright.subscribe(() => this.moveright.emit());
    this.compRef.instance.movedown.subscribe(() => this.movedown.emit());
  }

  ngOnDestroy(): void {
    if (this.compRef) {
      try {
        this.compRef.destroy();
      } catch (e) {
        // ignore
      }
      this.compRef = null;
    }
  }
}
